import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-shift-delivery-manage',
  templateUrl: './shift-delivery-manage.component.html',
  styleUrls: ['./shift-delivery-manage.component.scss'],
})
export class ShiftDeliveryManageComponent implements OnInit {
  shiftDeliveryData: any = {};
  carrierId: any;
  carrierNameError: string;
  accessKeyError: string;
  secretKeyError: string;

  constructor(private api: ApiIntegration, private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

    this.carrierId = this.route.snapshot.paramMap.get('id');
    if (this.carrierId) {
      this.api.getCarrierInfoById(this.user.accountOwnerId, this.carrierId, this.user.organizationId).subscribe((data: any) => {
        this.shiftDeliveryData = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }


  }


  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.shiftDeliveryData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  accessKeyBlur() {
    this.accessKeyError = "";
    if (!this.shiftDeliveryData.accessKey) {
      this.accessKeyError = 'Please enter access key';
    }
  }

  secretKeyBlur() {
    this.secretKeyError = "";
    if (!this.shiftDeliveryData.secretkey) {
      this.secretKeyError = 'Please enter secret key';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.accessKeyError = "";
    this.secretKeyError = "";

    if (!this.shiftDeliveryData.connectionName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.shiftDeliveryData.accessKey) {
      this.accessKeyError = 'Please enter access key';
    }
    if (!this.shiftDeliveryData.secretkey) {
      this.secretKeyError = 'Please enter secret key';
    }
    if (this.carrierNameError != "" || this.accessKeyError != "" || this.secretKeyError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateCarrierCredentials', {

      "accessKey": this.shiftDeliveryData.accessKey,
      "accountOwnerId": this.user.accountOwnerId,
      "carrierCode": this.shiftDeliveryData.carrierCode,
      "connectionName": this.shiftDeliveryData.connectionName,
      "organizationId": 1,
      "secretkey": this.shiftDeliveryData.secretkey,
      "carrierId": this.shiftDeliveryData.carrierId

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shift Delivery', 'Update Successfully');
          this.router.navigate(['/admin/customerCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }



}
